<template>
    <form @change="sendDataForSaving">
        <div class="row">
            <div
                class="col-lg-6"
            >
                <div class="form-group form-group-1">
                    <label for="" class="form-label">Type Address</label>

                    <VueGoogleAutocomplete
                        id="map1"
                        :country="`us`"
                        classname="form-control"
                        placeholder="Start typing"
                        v-on:placechanged="getAddressData"
                    >
                    </VueGoogleAutocomplete>

                </div>
            </div>
            <div
                class="col-lg-6"
            >
                <div class="form-group form-group-1">
                    <label for="" class="form-label">Address</label>

                    <VueGoogleAutocomplete
                        id="map2"
                        classname="form-control"
                        placeholder="Your address"
                       v-model="form.address"
                    >
                    </VueGoogleAutocomplete>

                </div>
            </div>


            <ValidationProvider
                name="Zip code"
                rules="required|min:5"
                v-slot="{ errors }"
                class="col-md-4"
            >
                <div class="form-group form-group-1">
                    <label for="" class="form-label">Zip</label>
                    <input
                        type="text"
                        class="form-control"
                        v-mask="'#####'"
                        v-model="form.zip"
                    >
                    <FormError :error="errors[0]" name="Zip code"></FormError>
                </div>
            </ValidationProvider>

            <ValidationProvider
                name="City"
                rules="required|latin|min:2|max:300"
                v-slot="{ errors }"
                class="col-md-4">
                <div class="form-group form-group-1">
                    <label for="" class="form-label">City</label>
                    <input
                        type="text"
                        class="form-control"
                        v-model="form.city"
                    >
                    <FormError :error="errors[0]" name="City"></FormError>
                </div>
            </ValidationProvider>

            <ValidationProvider
                name="State"
                rules="required"
                v-slot="{errors}"
                class="col-md-4 "
            >
                <div class="form-group form-group-1">
                    <label for="" class="form-label">State</label>

                        <input
                            type="text"
                            class="form-control"
                            v-model="form.state"
                        >

                    <FormError :error="errors[0]" name="State"></FormError>
                </div>
            </ValidationProvider>

            <ValidationProvider
                name="Period of living"
                v-slot="{ errors }"
                rules="latinAndNumbers|min:2|max:300"
                class="col-lg-12"
            >
                <div class="form-group form-group-1">
                    <label for="" class="form-label">How long have you lived at this address?</label>
                    <input
                        type="text"
                        class="form-control"
                        v-model="form.term_living"
                    >
                    <FormError :error="errors[0]" name="Period of living"></FormError>
                </div>
            </ValidationProvider>

            <ValidationProvider
                class="col-lg-12"
                name="Prior address"
                v-slot="{ errors }"
                rules="latinAndNumbers|min:2|max:300"
            >
                <div class="form-group form-group-1">
                    <label for="" class="form-label">If less than one year, enter you prior address</label>
                    <input
                        type="text"
                        class="form-control"
                        v-model="form.period_living"
                    >
                    <FormError :error="errors[0]"  name="Prior address"></FormError>
                </div>
            </ValidationProvider>

        </div>
    </form>
</template>

<script>

import VueGoogleAutocomplete from "vue-google-autocomplete";
export default {
    name: 'AddressForm',
    components: {VueGoogleAutocomplete},
    props: {
        user: {
            type: Object,
        }
    },
    emits:['data-changed'],
    data() {
        return {
            form: {
                address: null,
                address_latitude: null,
                address_longitude:null,
                zip: null,
                city: null,
                term_living: null,
                period_living: null,
                state: null,
            }
        }
    },
    methods: {
        sendDataForSaving() {
            this.$emit('data-changed', this.form);
        },
        setData() {
            for (const userKey in this.user.user_address) {
                for (const formKey in this.form) {
                    if (userKey === formKey) {
                        this.form[userKey] = this.user.user_address[formKey];
                    }
                }
            }
        },
        getAddressData(place) {
            let { administrative_area_level_1, locality, postal_code, route, street_number,longitude, latitude } = place
            if (route && street_number) {
                this.form.address = `${street_number} ${route} `;
            } else {
                this.form.address = route || street_number || '';
            }
            this.form.address_longitude = longitude
            this.form.address_latitude = latitude
            this.form.zip = postal_code
            this.form.city = locality
            this.form.state = administrative_area_level_1

        },
    },
    mounted() {
        this.setData();
        this.sendDataForSaving()
    }
}

</script>

<style scoped>

</style>
